import {
  BooleanField,
  CreateButton,
  Datagrid,
  List,
  ReferenceField,
  ReferenceInput,
  SelectInput,
  TextField,
  TopToolbar,
} from 'react-admin';

const stateFilters = [
  <ReferenceInput key="country" source="country_id" reference="countries" label="Country" alwaysOn>
    <SelectInput optionText="name" />
  </ReferenceInput>,
];

const ListActions = () => (
  <TopToolbar>
    <CreateButton />
  </TopToolbar>
);

export function StateList() {
  return (
    <List
      actions={<ListActions />}
      filters={stateFilters}
      sort={{ field: 'name', order: 'ASC' }}
      perPage={50}
    >
      <Datagrid rowClick="edit">
        <TextField source="name" />
        <TextField source="slug" />
        <ReferenceField source="country_id" reference="countries" label="Country">
          <TextField source="name" />
        </ReferenceField>
        <BooleanField source="is_active" label="Active" />
      </Datagrid>
    </List>
  );
}
